import { UserConsentDto } from '@/api/generated';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { LocalStorageKey } from '@/utils/localStorage/localStorage.util.ts';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QueryKeyEnum } from '../api/model/QueryKey.enum.ts';

type Req = {
  captchaToken?: string;
  password?: string;
  username: string;
};

type Response = void;

interface Return {
  error: AxiosError | null;
  generate: (req: Req) => Promise<Response>;
  isGenerating: boolean;
}

export const useGenerateOtt = (): Return => {
  const { restAuthenticationApi } = useApiClient();
  const { error, isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    meta: { disableErrorAlert: true },
    mutationFn: async req => {
      const sourceApp = localStorage.getItem(LocalStorageKey.SOURCE_APP) ?? undefined;
      localStorage.removeItem(LocalStorageKey.SOURCE_APP);
      
      await restAuthenticationApi.generateOtt(
        req.username,
        {
          consent: UserConsentDto.EmailConsentForLetsOrangeRecruitment,
        },
        req.captchaToken,
        req.password,
        sourceApp,
      );
    },
    mutationKey: [QueryKeyEnum.GENERATE_TOKEN],
  });

  return { error, generate: mutateAsync, isGenerating: isPending };
};
